import { generateMutations } from '../builder'

export default {
  ...generateMutations('getAdaptationBudgets', 'adaptationBudgets'),
}
